/**
 * Tiny markdown renderer (headings, paragraphs, lists, bold, inline code).
 * Intentionally minimal — no external dependency.
 */
import React from "react";

function inline(text) {
  // bold **x**, italic *x*, inline code `x`, links [text](url)
  const parts = [];
  let i = 0, idx = 0;
  const regex = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`|\[[^\]]+\]\([^)]+\))/g;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > i) parts.push(text.slice(i, m.index));
    const tok = m[0];
    if (tok.startsWith("**")) parts.push(<strong key={idx++}>{tok.slice(2, -2)}</strong>);
    else if (tok.startsWith("*")) parts.push(<em key={idx++}>{tok.slice(1, -1)}</em>);
    else if (tok.startsWith("`")) parts.push(<code key={idx++}>{tok.slice(1, -1)}</code>);
    else if (tok.startsWith("[")) {
      const tm = tok.match(/\[([^\]]+)\]\(([^)]+)\)/);
      if (tm) parts.push(<a key={idx++} href={tm[2]} target="_blank" rel="noreferrer">{tm[1]}</a>);
    }
    i = m.index + tok.length;
  }
  if (i < text.length) parts.push(text.slice(i));
  return parts;
}

export default function Markdown({ children }) {
  const src = String(children || "");
  const lines = src.split(/\r?\n/);
  const blocks = [];
  let list = null;
  let codeBuf = null;
  lines.forEach((line, idx) => {
    if (line.startsWith("```")) {
      if (codeBuf === null) codeBuf = [];
      else { blocks.push(<pre key={`c${idx}`}><code>{codeBuf.join("\n")}</code></pre>); codeBuf = null; }
      return;
    }
    if (codeBuf !== null) { codeBuf.push(line); return; }

    if (/^- /.test(line)) {
      list = list || [];
      list.push(line.replace(/^- /, ""));
      return;
    } else if (list) {
      blocks.push(<ul key={`l${idx}`}>{list.map((li, i) => <li key={i}>{inline(li)}</li>)}</ul>);
      list = null;
    }

    if (/^### /.test(line)) blocks.push(<h3 key={idx}>{inline(line.slice(4))}</h3>);
    else if (/^## /.test(line)) blocks.push(<h2 key={idx}>{inline(line.slice(3))}</h2>);
    else if (/^# /.test(line)) blocks.push(<h1 key={idx}>{inline(line.slice(2))}</h1>);
    else if (line.trim() === "") blocks.push(<div key={idx} style={{ height: 6 }} />);
    else blocks.push(<p key={idx}>{inline(line)}</p>);
  });
  if (list) blocks.push(<ul key="trailing">{list.map((li, i) => <li key={i}>{inline(li)}</li>)}</ul>);
  if (codeBuf !== null) blocks.push(<pre key="trailcode"><code>{codeBuf.join("\n")}</code></pre>);
  return <div className="bx-prose">{blocks}</div>;
}
